export default __webpack_public_path__ + "static/media/pates.76a46c2b.jpg";